import React from 'react';
import Icon from '../../../components/AppIcon';

const BrandingHeader = () => {
  return (
    <div className="w-full text-center space-y-4 mb-8 md:mb-10 lg:mb-12">
      <div className="flex justify-center mb-6">
        <div className="relative">
          <img 
            src="/assets/images/up_menor-1769132654249.png" 
            alt="UP MIDIA logo"
            className="h-24 md:h-28 lg:h-32 w-auto"
          />
          <div className="absolute -bottom-2 -right-2 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-secondary/20 flex items-center justify-center glow-secondary">
            <Icon name="Shield" size={20} color="var(--color-secondary)" />
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <p className="text-lg md:text-xl text-secondary font-medium">
          Painel Administrativo
        </p>
      </div>

      <div className="pt-4">
        <p className="text-sm md:text-base text-muted-foreground max-w-md mx-auto">
          Acesse o sistema de gerenciamento de conteúdo e personalize sua galeria digital
        </p>
      </div>

      <div className="flex items-center justify-center gap-2 pt-2">
        <div className="w-2 h-2 rounded-full bg-primary glow-primary"></div>
        <p className="text-xs text-muted-foreground font-caption">
          Sistema Seguro
        </p>
        <div className="w-2 h-2 rounded-full bg-secondary glow-secondary"></div>
      </div>
    </div>
  );
};

export default BrandingHeader;